/**
 * 09.10.26. Не удалять по требованию владельца системы.
 * Пять основных рассылок: заранее, за сутки, день рождения, за 2 часа, сбор ОС.
 * Шаблон основной, если он стоит в активной привязке одного из этих событий.
 * Связано с event_templates и переключателем на /templates.
 */

import type { EventTemplateBindingItem } from '@/api/templates';

export const CORE_BROADCAST_EVENT_TYPES = [
  'appointment_reminder_advance',
  'appointment_reminder_24h',
  'appointment_reminder_2h',
  'birthday',
  'feedback_request',
] as const;

export const templateCatalogIds = ['core', 'extra'] as const;

export type TemplateCatalogId = (typeof templateCatalogIds)[number];

const coreEvents = new Set<string>(CORE_BROADCAST_EVENT_TYPES);

export function collectCoreTemplateIds(bindings: EventTemplateBindingItem[]): Set<string> {
  const ids = new Set<string>();
  for (const binding of bindings) {
    if (!coreEvents.has(binding.event_type)) continue;
    const slots = [binding.generic_binding, ...(binding.channel_bindings || [])];
    for (const slot of slots) {
      if (!slot?.has_binding || !slot.mapping_active || !slot.template?.id) continue;
      ids.add(slot.template.id);
    }
  }
  return ids;
}
